import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'Store/mainStore';
import DashboardGrid from '../components/Common/DashboardGrid';
import useDashboard from "features/dashboard/hooks/useDashboard";
import { Tooltip } from '@nokia-csf-uxr/ccfk';
import IconButtons from '../components/Common/IconButtons';
import BookmarkFilledIcon from '@nokia-csf-uxr/ccfk-assets/latest/BookmarkFilledIcon';
import { updateFavouritesTotalCount } from '../store/dashboardSlice';
import DATAMART_API from 'Constants/services/datamart';
import { setError } from 'Store/general/auth';



const FavouriteCases = () => {
  // Sectors
  const dashboardSelector = useSelector((state: RootState) => state.dashboard);
  // Hooks
  const dispatch = useDispatch();
  const { getDashboardGidColumns } = useDashboard();
  // Prepaare the action column for the favourite cases grid
  const actionColoumn = {
    headerName: "",
    field: "",
    width: 60,
    minWidth: 60,
    maxWidth: 60,
    sortable: false,
    filter: false,
    cellRenderer: (params) => {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tooltip tooltip={"Remove from favourites"} placement="top">
            <IconButtons
              icon={BookmarkFilledIcon}
              //icon={BookmarkFilledIcon}
              iconColor={"var(--color-status-fault)"}
              onclick={() => removeFromFavourites(params?.data)}
              disabled={false}
            ></IconButtons>
          </Tooltip>
        </div>
      );
    },
  };
  const columnDefs = useMemo(() => {
    return [...getDashboardGidColumns(), actionColoumn];
  }, [getDashboardGidColumns, actionColoumn]);

  // Component state
  const [favGridData, setFavGridData] = useState({
    isLoading: true,
    label: "",
    id_key: "fav_case_list",
    overlayNoRowsTemplate: "No data available for the current selection",
    rowData: [],
    columnDefs: [],
  });

  useEffect(() => {
    // Get the favourites data from the dashboard state
    const rowData = dashboardSelector?.data?.favourites?.data;
    // Prepare the grid data
    const gridformattedData = {
      ...favGridData,
      rowData,
      isLoading: dashboardSelector?.data?.favourites?.isLoading,
      columnDefs: columnDefs,
    };
    setFavGridData(gridformattedData);

  }, [dashboardSelector?.data?.favourites]);

  // Function to remove an offer from favourites
  const removeFromFavourites = async (offerData) => {
    // Make the gird loading true
    const gridformattedData = {
      ...favGridData,
      isLoading: true
    };
    setFavGridData(gridformattedData);
    // Call the API to remove the offer from favourites
    const bookmark = await DATAMART_API.handleBookmark(offerData.offer_id, 'remove');
    // Check if the bookmark was successful
    if (bookmark && bookmark?.length > 0) {
      // Updaate the total count in the dashboard state
      dispatch(updateFavouritesTotalCount({ total_count: dashboardSelector.data.favourites.total_count - 1 }));
      // Show success message
      dispatch(
        setError({
          key: "info",
          value: {
            errorCode: null,
            errorMsg: "Offer removed form the favourites successfully!",
          },
        })
      );

    }
    else {
      // Show error message
      dispatch(
        setError({
          key: "error",
          value: {
            errorCode: null,
            errorMsg: "Failed to remove offer from favourites.",
          },
        })
      );
    }
  }
  
  return (
    <div className='dsh-olv-list-wrapper'>
      <DashboardGrid {...favGridData} />
    </div>
  )
}

export default FavouriteCases;